module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NImxGj/tc-custom/9780547539683.jpg?1709148266370",
      "alt": "This image is the cover for the book Foucault's Pendulum"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Foucault's Pendulum\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A literary prank leads to deadly danger in this “endlessly diverting” intellectual thriller by the author of "), _c('i', [_vm._v("The Name of the Rose")]), _vm._v(" ("), _c('i', [_vm._v("Time")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Bored with their work, three Milanese book editors cook up an elaborate hoax that connects the medieval Knights Templar with occult groups across the centuries. Becoming obsessed with their own creation, they produce a map indicating the geographical point from which all the powers of the earth can be controlled—a point located in Paris, France, at Foucault’s Pendulum."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But in a fateful turn the joke becomes all too real. When occult groups, including Satanists, get wind of the Plan, they go so far as to kill one of the editors in their quest to gain control of the earth. Orchestrating these and other diverse characters into his multilayered semiotic adventure, Umberto Eco has created a superb cerebral entertainment."), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("\"An intellectual adventure story…sensational, thrilling, and packed with arcana.\"—"), _c('i', [_vm._v("The Washington Post Book World")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Umberto Eco\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0